import { render, staticRenderFns } from "./joinDialog.vue?vue&type=template&id=2d3cf932&scoped=true"
import script from "./joinDialog.vue?vue&type=script&lang=js"
export * from "./joinDialog.vue?vue&type=script&lang=js"
import style0 from "./joinDialog.vue?vue&type=style&index=0&id=2d3cf932&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3cf932",
  null
  
)

export default component.exports